var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleArrow17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
    id: "Combined-Shape",
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M5.5 8.5H11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 11l2.5-2.5L9 6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow17);
export default __webpack_public_path__ + "static/media/circle-arrow-17.cfa3ee67.svg";
export { ForwardRef as ReactComponent };